// Css
import './schedule.css';

// Common
import React from 'react';

// YMAPS
import { YMaps } from 'react-yandex-maps';

// Moment
import moment from 'moment';

// Include components Ant design
import {} from 'antd';

moment.locale('ru');

class Schedule extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      center: [55.753215, 37.622504],
      ymaps: false,
      stopStatus: {
        start: ['Посадка', 'Место подачи ТС'],
        intermediate: ['Остановка', 'Промежуточный пункт'],
        end: ['Высадка', 'Конечный  пункт'],
      },
      data: null,
    };
  }

  componentDidMount() {
    // console.log(this.state.ymaps);
    // if(!this.props.schedule_data.state){
    //     this.setState((state, props) => ({
    //         data: this.props.schedule_data
    //     }))
    // }
  }

  componentDidUpdate(prevProps, prevState) {
    // console.log(this.state, this.state.data, this.props.schedule_data);
    if (
      this.state.ymaps &&
      (this.state.data == null ||
        this.props.schedule_data !== prevProps.schedule_data)
    ) {
      let schedule_data = this.props.schedule_data,
        points = [];
      // console.log(schedule_data);
      // console.log(schedule_data.stops);
      schedule_data.stops.forEach((item, index) => {
        points.push(item.landing_place);
      });
      this.state.ymaps.route(points).then(
        route => {
          //let standby_time_string = 0;
          let hourse_landing = 0;
          let minute_landing = 0;
          for (var i = 0; i < route.getPaths().getLength(); i++) {
            let way = route.getPaths().get(i);
            let km = way.getLength() / 1000; // Расстояние
            schedule_data.stops[i + 1].drive_distance = km.toFixed(3) + ' км';
            schedule_data.stops[i + 1].drive_time = way.getJamsTime();
            let time_landing = schedule_data.stops[i + 1].landing_time.split(
              ':'
            );
            if (time_landing.length > 1) {
              hourse_landing = hourse_landing + parseInt(time_landing[0]);
              minute_landing = minute_landing + parseInt(time_landing[1]);
            }
          }
          let hourse_minute_landing = 0;
          if (minute_landing > 60) {
            hourse_minute_landing = parseInt(minute_landing / 60);
            minute_landing = (minute_landing % 60).toFixed(2) + minute_landing;
          }
          hourse_landing = hourse_minute_landing + hourse_landing;
          if (hourse_landing < 10) {
            hourse_landing = '0' + hourse_landing;
          }
          if (minute_landing < 10) {
            minute_landing = '0' + minute_landing;
          }
          schedule_data.travel_time = moment
            .duration(parseInt(route.getJamsTime()), 'seconds')
            .humanize();
          schedule_data.route_length =
            (route.getLength() / 1000).toFixed(3) + ' км';
          schedule_data.standby_time =
            hourse_landing + ' ч ' + minute_landing + ' мин';

          this.setState((state, props) => ({
            data: { ...schedule_data },
          }));
        },
        function(error) {
          console.log(error);
        }
      );
    }
  }

  init_ymaps(ymaps) {
    this.setState((state, props) => ({
      ymaps: ymaps,
    }));
  }

  // сборка марщрута (старт, пром. остановки, конец)
  renderStops() {
    let stopStatus, stopPlace;
    let stops = this.state.data.stops;
    const stopsState = this.state.stopStatus;
    const stopsNum = stops.length - 1;
    return (
      <div className="traffic-schedule__scheme">
        {stops.map((item, index) => {
          if (index === 0) {
            stopStatus = stopsState.start[0];
            stopPlace = stopsState.start[1];
          } else if (index === stopsNum) {
            stopStatus = stopsState.end[0];
            stopPlace = stopsState.end[1];
          } else {
            stopStatus = stopsState.intermediate[0] + ' ' + index;
            stopPlace = stopsState.intermediate[1] + ' ' + index;
          }
          return (
            <div key={index} className="traffic-schedule__scheme__item">
              <span className="traffic-schedule__scheme__col">
                <div className="additional-info">
                  <span>
                    {parseInt(item.drive_time) >= 0 &&
                      moment
                        .duration(parseInt(item.drive_time), 'seconds')
                        .humanize()}
                  </span>
                  <span>{item.drive_distance}</span>
                </div>
                <span className="lbl">{stopStatus}</span>
                <span className="value">{item.landing_time}</span>
              </span>
              <span className="traffic-schedule__scheme__col">
                <span className="stop-num">{index + 1}</span>
              </span>
              <span className="traffic-schedule__scheme__col">
                <span className="lbl">{stopPlace}</span>
                <span className="value">{item.landing_place}</span>
              </span>
            </div>
          );
        })}
      </div>
    );
  }

  render() {
    let schedule = this.state.data;
    let travel_time = this.state.data !== null && schedule.travel_time;
    //let end = this.state.data !== null && schedule.end;
    let stops = this.state.data !== null && schedule.stops;
    let end_time = 0;
    stops &&
      stops.forEach((item, index) => {
        if (item.landing_time !== '') {
          let time_array = item.landing_time.split(':');
          let hourse = parseInt(time_array[0]) * 60 * 60;
          let minute = parseInt(time_array[1]) * 60;
          end_time = hourse + minute + end_time;
          // console.log();
          // console.log(moment(item.landing_time).format('H:mm'));
          // console.log(moment(item.landing_time).format('s'));
          // console.log(moment(item.landing_time).format('s').second());
          // console.log(moment(item.landing_time).format('ss'));
          // console.log(moment(item.landing_time).second());
        }
        if (item.drive_time !== '') {
          end_time = end_time + item.drive_time;
        }
      });

    return (
      <div className="traffic-schedule">
        <div className="traffic-schedule__stops">
          <div className="traffic-schedule__start-time">
            {this.state.data !== null && schedule.start}
          </div>
          {this.state.data !== null && this.renderStops()}
          <div className="traffic-schedule__end-time">
            {this.state.data !== null &&
              moment()
                .seconds(end_time)
                .format('HH:mm')}
          </div>
          <div className="traffic-schedule__info">
            <div className="traffic-schedule__info__item">
              <span>
                <p>Рассчетное время в&nbsp;пути:</p>
              </span>
              <span>
                <p>{this.state.data !== null && travel_time}</p>
              </span>
            </div>
            <div className="traffic-schedule__info__item">
              <span>
                <p>Время ожидания:</p>
              </span>
              <span>
                <p>{this.state.data !== null && schedule.standby_time}</p>
              </span>
            </div>
            <div className="traffic-schedule__info__item">
              <span>
                <p>Длина маршрута:</p>
              </span>
              <span>
                <p>{this.state.data !== null && schedule.route_length}</p>
              </span>
            </div>
          </div>
        </div>
        <YMaps
          query={{
            apikey: 'b6a66b8f-dc2c-4946-a916-0fb0ca680e5a',
          }}
          onApiAvaliable={ymaps => this.init_ymaps(ymaps)}
        />
      </div>
    );
  }
}

export default Schedule;
